import { Injectable } from '@angular/core';

import { ApiService } from '@app/services';
import { PowerBiReport, PowerBiData, PowerBiAccess } from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class PowerBiService {

    constructor(
        private apiService: ApiService
    ) {}
      
    async getPowerBiToken(): Promise<PowerBiAccess | null> {
        
        let powerBiAccess: PowerBiAccess|null = null;
        
        let response = await this.apiService.get('power-bi/access');
        if(response?.data){
            powerBiAccess = response.data;
        }
        
        return powerBiAccess;

    }
    
    async getReports(authCode: string | null, redirectUrl: string): Promise<PowerBiReport[]> {
        
        let powerBiReports: Array<PowerBiReport> = [];
        let params: any = {
            redirectUrl: this.checkUrl(redirectUrl)
        };
      
        if (authCode) {
            params.authCode = authCode;
        }
        
        let response = await this.apiService.get('power-bi/reports', params);
        if(response?.data){
            powerBiReports = response?.data;
        }
        
        return powerBiReports;

    }

    async getReportDetails(authCode: string | null, reportId: string, redirectUrl: string): Promise<PowerBiData|null> {
        
        let powerBiData: PowerBiData|null = null;
        
        let params: any = {
            redirectUrl: this.checkUrl(redirectUrl)
        };
      
        if (authCode) {
            params.authCode = authCode;
        }
        
        let response = await this.apiService.get('power-bi/report/' + reportId + '/details', params);
        if(response?.data){
            powerBiData = response?.data;
        }
        
        return powerBiData;

    }

    private checkUrl(redirectUrl: string) {
        if (redirectUrl.indexOf('?') > -1) {
            return redirectUrl.split('?')[0];
        }
        return redirectUrl;
    }
}
